import { Pagination } from 'shared/domains/common-ui';
import { useSearchContext } from '../SearchProvider';
import { PaginationContainer } from './styled';
export function SearchResultsPagination(props) {
    const { totalCount, limit } = props;
    const { resultOffset, setResultOffset } = useSearchContext();
    if (!totalCount || !limit) {
        return null;
    }
    return (<PaginationContainer>
      <Pagination count={totalCount} limit={limit} offset={resultOffset} setOffset={setResultOffset}/>
    </PaginationContainer>);
}
